import {
  OBTENER_USUARIO_EXITO,
  OBTENER_USUARIO_ERROR,
  LIMPIAR_ERRORES,
  OBTENER_PRODUCTOS_EXITO,
  OBTENER_PRODUCTOS_ERROR,
  OBTENER_CLIENTE_HABILITADO_EXITO,
  OBTENER_CLIENTE_HABILITADO_ERROR,
  OBTENER_CATEGORIAS_EXITO,
  OBTENER_CATEGORIAS_ERROR,
  CREAR_CATEGORIA_EXITO,
  CREAR_CATEGORIA_ERROR,
  OBTENER_CLIENTE_EXITO,
  OBTENER_CLIENTE_ERROR,
  OBTENER_PROVEEDORES_EXITO,
  OBTENER_PROVEEDORES_ERROR,
  OBTENER_USUARIOS_EXITO,
  OBTENER_USUARIOS_ERROR,
  OBTENER_OBRAS,
  CREAR_OBRA,
  ACTUALIZAR_OBRA,
  OBRAS_ERROR,
  CREAR_INGRESO_SUCCESS,
  CREAR_INGRESO_ERROR,
  CREAR_PROVEEDOR_EXITO,
  CREAR_PROVEEDOR_ERROR,
  REGISTRAR_SALIDA_REQUEST,
  REGISTRAR_SALIDA_SUCCESS,
  REGISTRAR_SALIDA_FAILURE,
  GET_REPORTE_SALIDAS,
  CREAR_PRESTAMO_EXITOSO,
  CREAR_PRESTAMO_ERROR,
  OBTENER_PRODUCTOS_SALIDAS_EXITO,
  OBTENER_PRODUCTOS_PRESTAMOS_EXITO,
  OBTENIENDO_PRESTAMOS_EXITO,
  OBTENIENDO_PRESTAMOS_ERROR,
  CREAR_PRODUCTO,
  ACTUALIZAR_PRODUCTO,
  SET_ERROR,
  SET_LOADING,
  GET_REPORTE_INGRESOS,
  OBTENER_AUTORIZADOS_EXITO,
  OBTENER_AUTORIZADOS_ERROR,
  CREAR_AUTORIZADO_EXITO,
  CREAR_AUTORIZADO_ERROR,
  ACTUALIZAR_AUTORIZADO_EXITO,
  ACTUALIZAR_AUTORIZADO_ERROR,
  OBTENER_PRESTAMOS_ACTIVOS,
  DEVOLVER_PRESTAMO,
  FETCH_AUTORIZADOS_REQUEST,
  FETCH_AUTORIZADOS_SUCCESS,
  FETCH_AUTORIZADOS_FAILURE,
  ELIMINAR_PRODUCTO,
} from "../types";

// Se eliminaron las acciones y el estado relacionados con login, logout y token

const initialState = {
  salida: null,
  clienteHabilitado: null,
  usuario: [],
  usuarios: [],
  clientes: [],
  user: null,
  productos: [],
  productosSalidas: [],
  productosPrestamos: [],
  categorias: [],
  prestamos: [],
  proveedores: [],
  prestamosrep: [],
  obras: [],
  prestamosActivos: [],
  categorianombre: "",
  error: null,
  autorizados: [],
  autorizadosCliente: [],
  loading: true,
  reporteSalidas: [],
  reporteIngresos: [],
  ingresos: [],
};

export const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    // --- Obtención de usuario autenticado por SSO ---
    case OBTENER_USUARIO_EXITO:
      return {
        ...state,
        usuario: action.payload,
        loading: false,
        error: null,
      };
    case OBTENER_USUARIO_ERROR:
      return {
        ...state,
        usuario: [],
        loading: false,
        error: action.payload,
      };

    // --- Otros reducers conservados ---
    case OBTENER_PRESTAMOS_ACTIVOS:
      return {
        ...state,
        prestamosActivos: action.payload,
      };
    case DEVOLVER_PRESTAMO:
      return {
        ...state,
        prestamosActivos: state.prestamosActivos.filter(
          (prestamo) => prestamo.id !== action.payload
        ),
      };
    case FETCH_AUTORIZADOS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ELIMINAR_PRODUCTO:
      return {
        ...state,
        productos: state.productos.filter((prod) => prod.id !== action.payload),
      };
    case FETCH_AUTORIZADOS_SUCCESS:
      return {
        ...state,
        loading: false,
        autorizadosCliente: action.payload,
      };
    case FETCH_AUTORIZADOS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREAR_PRODUCTO:
      return {
        ...state,
        productos: [...state.productos, action.payload],
        error: null,
      };
    case OBTENER_AUTORIZADOS_EXITO:
      return {
        ...state,
        autorizados: action.payload,
        error: null,
      };
    case OBTENER_AUTORIZADOS_ERROR:
      return {
        ...state,
        autorizados: [],
        error: action.payload,
      };
    case CREAR_AUTORIZADO_EXITO:
      return {
        ...state,
        autorizados: [...state.autorizados, action.payload],
        error: null,
      };
    case CREAR_AUTORIZADO_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ACTUALIZAR_AUTORIZADO_EXITO:
      return {
        ...state,
        autorizados: state.autorizados.map((autorizado) =>
          autorizado.id === action.payload.id ? action.payload : autorizado
        ),
        error: null,
      };
    case ACTUALIZAR_AUTORIZADO_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ACTUALIZAR_PRODUCTO:
      return {
        ...state,
        productos: state.productos.map((producto) =>
          producto.id === action.payload.id ? action.payload : producto
        ),
        error: null,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case OBTENER_OBRAS:
      return {
        ...state,
        obras: action.payload,
        error: null,
      };
    case CREAR_OBRA:
      return {
        ...state,
        obras: [...state.obras, action.payload],
        error: null,
      };
    case ACTUALIZAR_OBRA:
      return {
        ...state,
        obras: state.obras.map((obra) =>
          obra.id === action.payload.obra.id ? action.payload.obra : obra
        ),
        error: null,
      };
    case OBRAS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case REGISTRAR_SALIDA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_REPORTE_SALIDAS:
      return {
        ...state,
        reporteSalidas: action.payload || [],
      };
    case GET_REPORTE_INGRESOS:
      return {
        ...state,
        reporteIngresos: action.payload || [],
      };
    case REGISTRAR_SALIDA_SUCCESS:
      return {
        ...state,
        loading: false,
        salida: action.payload,
        error: null,
      };
    case CREAR_PRESTAMO_EXITOSO:
      return {
        ...state,
        prestamos: [...state.prestamos, action.payload],
        error: null,
      };
    case CREAR_PRESTAMO_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case REGISTRAR_SALIDA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case OBTENER_PRODUCTOS_EXITO:
      return {
        ...state,
        productos: action.payload,
        loading: false,
        error: null,
      };
    case OBTENER_PRODUCTOS_SALIDAS_EXITO:
      return {
        ...state,
        productosSalidas: action.payload,
        loading: false,
        error: null,
      };
    case OBTENIENDO_PRESTAMOS_EXITO:
      return { ...state, loading: false, prestamosrep: action.payload };
    case OBTENIENDO_PRESTAMOS_ERROR:
      return { ...state, loading: false, error: action.payload };
    case OBTENER_PRODUCTOS_PRESTAMOS_EXITO:
      return {
        ...state,
        productosPrestamos: action.payload,
        loading: false,
        error: null,
      };
    case CREAR_INGRESO_SUCCESS:
      return { ...state, ingreso: action.payload };
    case CREAR_INGRESO_ERROR:
      return { ...state, error: action.payload };
    case CREAR_CATEGORIA_EXITO:
      return {
        ...state,
        categorias: [...state.categorias, action.payload],
      };
    case CREAR_CATEGORIA_ERROR:
      return { ...state, error: action.payload };
    case CREAR_PROVEEDOR_EXITO:
      return {
        ...state,
        proveedores: [...state.proveedores, action.payload],
      };
    case CREAR_PROVEEDOR_ERROR:
      return { ...state, error: action.payload };
    case OBTENER_PRODUCTOS_ERROR:
      return {
        ...state,
        productos: [],
        loading: false,
        error: action.payload,
      };
    case OBTENER_PROVEEDORES_EXITO:
      return {
        ...state,
        proveedores: action.payload,
        loading: false,
        error: null,
      };
    case OBTENER_USUARIOS_EXITO:
      return {
        ...state,
        usuarios: action.payload,
        loading: false,
        error: null,
      };
    case OBTENER_USUARIOS_ERROR:
      return {
        ...state,
        usuarios: [],
        loading: false,
        error: action.payload,
      };
    case OBTENER_CLIENTE_EXITO:
      return {
        ...state,
        clientes: action.payload,
        loading: false,
        error: null,
      };
    case OBTENER_CLIENTE_ERROR:
      return {
        ...state,
        clientes: [],
        loading: false,
        error: action.payload,
      };
    case OBTENER_CLIENTE_HABILITADO_EXITO:
      return {
        ...state,
        clienteHabilitado: action.payload,
        error: null,
      };
    case OBTENER_CLIENTE_HABILITADO_ERROR:
      return {
        ...state,
        clienteHabilitado: false,
        error: action.payload,
      };
    case OBTENER_PROVEEDORES_ERROR:
      return {
        ...state,
        proveedores: [],
        loading: false,
        error: action.payload,
      };
    case OBTENER_CATEGORIAS_EXITO:
      return {
        ...state,
        categorias: action.payload,
        loading: false,
        error: null,
      };
    case OBTENER_CATEGORIAS_ERROR:
      return {
        ...state,
        categorias: [],
        loading: false,
        error: action.payload,
      };
    case CREAR_CATEGORIA_EXITO:
      return {
        ...state,
        categorias: [...state.categorias, action.payload],
        error: null,
      };
    case CREAR_CATEGORIA_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case LIMPIAR_ERRORES:
      return {
        ...state,
        error: null,
      };
    default:
      return state;
  }
};